export enum BootstrapStatuses {
  IDLE = 'idle',
  LOADING = 'loading',
  READY = 'ready',
  FAILED = 'failed',
}
